import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserService } from 'src/app/services/user/user.service';

interface FooterLink {
  name: string;
  route: string;
  fragment?: string;
}

@Component({
  selector: 'app-footer-v2',
  templateUrl: './footer-v2.component.html',
  styleUrl: './footer-v2.component.scss'
})
export class FooterV2Component implements OnInit {

  public links: FooterLink[];
  public companyLinks: FooterLink[];
  private isBrowser: boolean;
  public copyrightText = '';
  public contactEmail: string = '';
  public companyMemberPhoneNumber: string = '';
  public companyPhoneNumber: string = '';
  public logoUrl: string = '';

  constructor(
    public userService: UserService,
    private configService: ConfigService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.links = this.configService.get('footerLinks');
    // Brands that have not defined a company column simply don't render one.
    this.companyLinks = this.configService.get('footerCompanyLinks') ?? [];
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.contactEmail = this.configService.getTextFromKey('contact-email-address');
    this.companyMemberPhoneNumber = this.configService.getTextFromKey('phone-number-for-member');
    this.companyPhoneNumber = this.configService.getTextFromKey('company-phone-number');
    this.logoUrl = this.configService.get('logo');
  }

  ngOnInit() {
    const currentYear = new Date().getFullYear();
    this.copyrightText = this.configService
      .get('copyrightText')
      .replace(/\{\{year}}|\[year]|%year%/gi, currentYear);
  }

  // Members get the 24/7 helpline number instead of the general one.
  public get isMember(): boolean {
    return (
      this.userService.isUserStoredInServicePremium() ||
      this.userService.isUserStoredInServiceBasicPlus()
    );
  }

  public onLinkClick(link: FooterLink): void {
    // Fragment links rely on the router's anchor scrolling, so don't force the top.
    if (link.fragment) return;
    this.scrollToTop();
  }

  public scrollToTop(): void {
    if (!this.isBrowser) return;
    window.scrollTo({ top: 0, behavior: 'instant' });
  }
}
